import styled from 'vue-styled-components';

const buttonProps = {
	size: {
		type: String,
		default: '2rem',
	},
};

const styledCircleButton = styled('button', buttonProps)`
  display: block;
  cursor: pointer;
  border: 0.1rem solid ${props => props.theme.lightGrey};
  border-radius: 50%;
  width: ${props => props.size};
  height: ${props => props.size};
  padding: 0.3rem;
  transition: .5s ease;

  &:focus {
    outline: none;
  }
`;

export { styledCircleButton as default };
